/**
 * Service to handle API calls for Transfers.
 * Created on 12-11-2024
 */
import axios from "../services/axiosService.js";
import CommonService from "../services/commonService.js";

//  Mock Data imports
import transfersData from '../assets/data/transfers.json';

class TransferService {

  commonService = new CommonService();

  constructor() {

    this.apiPointer = process.env.REACT_APP_WEB_API_POINTER;
    this.apiFolder = process.env.REACT_APP_WEB_API_FOLDER;

    //  Headers
    this.headers = { "Content-type": "application/json; charset=UTF-8", Accept: "application/json" };

    //  API url methods
    this.apiUrl = {
      getTransfers: '/Prompt/GetPPTResponse?project_UUID=<vProjectId>',
      setInsertOrDiscardTransfers: '/Prompt/InsertDiscardPPTResponse'
    };

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      // 'getTransfers',
      // 'setInsertOrDiscardTransfers'
    ];
  }

  /**
   * Function to get transfers
   * @param {*} projectId 
   * @returns 
   */
  getTransfers = async (projectId) => {
    try {
      if (this.apiPointer.toLowerCase() === "local" || this.mockApiUrl.includes("getTransfers")) {
        return Promise.resolve(transfersData);
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl = vApiEndpoint + this.apiFolder + this.apiUrl.getTransfers.replace("<vProjectId>", projectId);
        return await axios
          .get(vUrl, { headers: this.headers })
          .then((res) => {
            const response = res?.data;
            return response;
          });
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "TransferService",
        "getTransfers"
      );
    }
  }

  /**
   * Function to insert or discard transfers
   * @param {*} vResponse 
   * @param {*} vFlag 
   * @returns 
   */
  setInsertOrDiscardTransfers = async (vResponse, vFlag) => {
    const vData = {
      "responseId": vResponse.responseId,
      "insertDiscardFlag": vFlag
    };
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("setInsertOrDiscardTransfers")
      ) {
        return Promise.resolve('Transfer updated successfully');
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl = vApiEndpoint + this.apiFolder + this.apiUrl.setInsertOrDiscardTransfers;
        return await axios
          .post(vUrl, vData)
          .then((response) => {
            const res = response;
            return res;
          });
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "TransferService",
        "setInsertOrDiscardTransfers"
      );

    }
  }
}

export default TransferService;